module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf483b8231855f2bab0e0b42a834d15f3.f483b823.png";